module.exports = __webpack_public_path__ + "static/img/icon-guidance-yellow.6c249ba0.svg";